import React, { useEffect, useState } from "react";
import "./home.css";
import appLogo from "../../assets/logo_1024.png";
import contentServiceApi from "../../service/contentService";

export default function Home() {
  const [openFaq, setOpenFaq] = useState(0);
  const [storeInfo, setStoreInfo] = useState({
    ios_url: "#!",
    android_url: "#!",
    is_ios_released: false,
    is_android_released: false,
  });
  
  useEffect(() => {
    contentServiceApi.getAppConfig().then((response) => {
      setStoreInfo(response.data);
    });
  }, []);

  const handleStoreClick = (e, isReleased, storeName, url) => {
    if (!isReleased || url === "#!") {
      e.preventDefault();
      alert(`Ứng dụng trên ${storeName} đang trong quá trình phê duyệt!`);
    }
  };
  
  // Danh sách tính năng dùng SVG chuẩn theo Wireframe
  const features = [
    {
      type: "camera",
      title: "Chụp Hình Dò Trực Tiếp",
      description:
        "Chỉ cần mở camera và hướng vào tờ vé số, AI nhận diện ngay.",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
      ),
    },
    {
      type: "gallery",
      title: "Tải Ảnh Từ Thư Viện",
      description:
        "Dễ dàng chọn ảnh từ thư viện hình ảnh của điện thoại để ứng dụng tự động phân tích và tra cứu kết quả.",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      ),
    },
    {
      type: "voice",
      title: "Đọc Giọng Nói Thông Minh",
      description:
        "Trợ lý AI đọc to rõ ràng kết quả trúng thưởng, rất tiện lợi cho người lớn tuổi.",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="23" />
          <line x1="8" y1="23" x2="16" y2="23" />
        </svg>
      ),
    },
    {
      type: "history",
      title: "Lưu Lịch Sử Mua Vé",
      description:
        "Tự động lưu danh sách vé đã dò và thông báo ngay khi đài quay kết quả mới.",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
    },
  ];

  const steps = [
    {
      number: "01",
      title: "Chọn Phương Thức",
      description: "Mở ứng dụng và chọn Chụp trực tiếp hoặc Tải ảnh từ thư viện.",
    },
    {
      number: "02",
      title: "Căn Chỉnh Khung",
      description: "Đưa camera hướng vào tờ vé số sao cho dãy số nằm trọn trong khung.",
    },
    {
      number: "03",
      title: "AI Phân Tích",
      description: "Hệ thống AI tự động phân tích tên đài, ngày mở thưởng và dãy số dự thưởng.",
    },
    {
      number: "04",
      title: "Kết Quả",
      description: "Hiển thị chi tiết giải thưởng và thông báo.",
    },
  ];

  const faqs = [
    {
      question: "Ứng dụng có chính xác 100% không?",
      answer: "Ứng dụng sử dụng AI để nhận diện thông tin trên vé và đối chiếu với dữ liệu kết quả xổ số. Người dùng nên kiểm tra lại vé gốc và xác nhận với đơn vị phát hành/đại lý khi có kết quả trúng thưởng.",
    },
    {
      question: "App có hỗ trợ đủ 3 miền không?",
      answer: "Có. Ứng dụng hỗ trợ tra cứu kết quả xổ số miền Bắc, miền Trung và miền Nam.",
    },
  ];

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="home-page">
      {/* ================= HERO SECTION ================= */}
      <section className="hero-section" id="about">
        <div className="home-container hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="hero-badge-dot" />
              PHIÊN BẢN MỚI - NHẬN DIỆN AI VISION 4.0
            </div>

            <h1 className="hero-title">
              Dò Kết Quả Xổ Số
              <br />
              <span>Nhanh Chóng & Chính Xác</span>
              <br />
              Cùng <em>Trí Tuệ Nhân Tạo</em>
            </h1>

            <p className="hero-description">
              Ứng dụng di động thông minh giúp bạn kiểm tra kết quả xổ số
              kiến thiết 3 Miền (Bắc, Trung, Nam) hoàn toàn tự động.
              <br />
              Không sợ nhìn nhầm số, trúng thưởng bỏ sót!
            </p>

            <div className="hero-actions">
              <button
                type="button"
                className="hero-download-btn"
                onClick={() => scrollTo("download")}
              >
                {/* <span className="btn-icon">⬇</span> */}
                <i className="fa-solid fa-download" />
                Tải App Cho Điện Thoại
              </button>

              <button
                type="button"
                className="hero-guide-btn"
                onClick={() => scrollTo("guide")}
              >
                <span className="play-icon">▶</span>
                Xem Hướng Dẫn
              </button>
            </div>
          </div>

          {/* VISUAL - PHONE */}
          <div className="hero-visual">
            <div className="static-glow-background">
              <div className="static-ring ring-orange"></div>
              <div className="static-ring ring-blue"></div>
            </div>

            <div className="hero-phone">
            <div className="phone-notch" />
                
          <div className="phone-screen">
          {/* Phần thân ứng dụng */}
          <div className="phone-app-body">
            <div className="phone-brand">
              <img src={appLogo} alt="Logo App" className="phone-brand-logo" />
              <h3 className="phone-brand-title">Dò Vé Số AI</h3>
              <p className="phone-brand-desc">
                Chụp ảnh hoặc đọc thông tin vé số(Ngày, đài, số) để tự động phân tích kết quả
              </p>
            </div>

            <div className="phone-actions">
            {/* Nút 1: Đọc số để dò - Micro */}
            <button type="button" className="phone-btn btn-navy">
              <svg className="btn-svg-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
              </svg>
              <span>Đọc số để dò</span>
            </button>

            {/* Nút 2: Chụp hình vé số - Camera */}
            <button type="button" className="phone-btn btn-navy">
              <svg className="btn-svg-icon" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="3.2" />
                <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
              </svg>
              <span>Chụp hình vé số</span>
            </button>

            {/* Nút 3: Chọn từ thư viện - Gallery (2 Tấm ảnh đè nhau) */}
            <button type="button" className="phone-btn btn-orange">
              <svg className="btn-svg-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H9l2-3.5zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z" />
              </svg>
              <span>Chọn từ thư viện</span>
            </button>
          </div>
            </div>

                {/* Thanh điều hướng bo tròn nổi ở dưới cùng */}
                <div className="phone-bottom-nav">
                  {/* Trang chủ - Active (Màu cam) */}
                  <div className="nav-item active">
                    <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    <small>Trang chủ</small>
                  </div>

                  {/* Kết quả - Màn hình TV/Monitor */}
                  <div className="nav-item">
                    <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z" />
                    </svg>
                    <small>Kết quả</small>
                  </div>

                  {/* Lịch sử mua vé - Đồng hồ xoay ngược có kim */}
                  <div className="nav-item">
                    <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
                    </svg>
                    <small>Lịch sử mua...</small>
                  </div>

                  {/* Cài đặt - Bánh răng 8 cánh */}
                  <div className="nav-item">
                    <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
                    </svg>
                    <small>Cài đặt</small>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="hero-side-logo">
              <img src={appLogo} alt="App Logo" className="side-logo-img" />
            </div> */}

            <div className="hero-slogan">
              Dò số dễ dàng
              <br />
              Trúng thưởng
              <br />
              <strong>thật vui!</strong>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FEATURES SECTION ================= */}
      <section className="features-section" id="features">
        <div className="home-container">
          <div className="section-heading center">
            <h2>
              Tính Năng <span>Đột Phá</span>
            </h2>

            <div className="heading-line" />

            <p>
              Trải nghiệm dò số thông minh toàn diện với công nghệ AI Vision.
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className={`feature-icon icon-box-${feature.type}`}>
                  {feature.iconSvg}
                </div>

                <h3>{feature.title}</h3>

                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= GUIDE SECTION ================= */}
      <section className="guide-section" id="guide">
        <div className="home-container guide-layout">
          <div className="guide-left">
            <div className="section-heading">
              <h2>Hướng Dẫn Sử Dụng</h2>
              <div className="heading-line" />
              <p>Chỉ với 4 bước đơn giản, bạn đã có kết quả!</p>
            </div>

            <div className="steps-wrapper">
              {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                  <div className="step-card">
                    <div className="step-number">{step.number}</div>
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>

                  {index < steps.length - 1 && (
                    <div className="step-arrow">
                      <span>›</span>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="download-promo" id="download">
            <div className="download-promo-bg" />

            <div className="download-promo-content">
              <h2>
                Dò Vé Số Nhanh Hơn
                <br />
                <span>Với AI</span>
              </h2>

              <p>
                Chụp vé số, tải ảnh hoặc đọc số bằng giọng nói. AI tự động
                nhận diện và đối chiếu kết quả xổ số 3 miền.
              </p>

              <div className="store-buttons">
                <a
                  href={storeInfo.is_ios_released ? storeInfo.ios_url : "#!"}
                  target={storeInfo.is_ios_released ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className="store-button app-store-button"
                  onClick={(e) =>
                    handleStoreClick(e, storeInfo.is_ios_released, "App Store", storeInfo.ios_url)
                  }
                >
                  <span className="store-icon">
                    <svg width="22" height="26" viewBox="0 0 170 170" fill="currentColor">
                      <path d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.19-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.26 2.13-9.5 3.24-12.74 3.35-4.34.13-9.13-1.9-14.38-6.08-3.48-2.82-7.42-7.52-11.83-14.1-6.19-9.12-11.1-19.8-14.71-32.03-3.61-12.23-5.42-23.82-5.42-34.78 0-14.23 3.59-25.89 10.77-34.98 7.18-9.09 16.19-13.72 27.02-13.88 4.67 0 9.89 1.14 15.66 3.42 5.76 2.28 9.84 3.42 12.23 3.42 2.17 0 6.35-1.19 12.55-3.58 6.2-2.39 11.36-3.48 15.49-3.26 12.06.87 21.6 5.48 28.62 13.85-10.76 6.52-16.03 15.75-15.82 27.69.22 9.34 3.8 17.06 10.75 23.15 6.95 6.09 15.22 9.4 24.8 9.95-2.5 7.49-5.98 15.32-10.43 23.49zM119.22 31.8c0-7.39 2.68-14.4 8.04-21.03 5.36-6.63 12.06-10.77 20.1-12.42.11 1.09.16 1.96.16 2.61 0 7.28-2.73 14.28-8.19 21.01-5.46 6.73-12.21 10.89-20.25 12.48-.11-.87-.16-1.76-.16-2.65z" />
                    </svg>
                  </span>
                  <span className="store-btn-text">
                    <strong>App Store</strong>
                  </span>
                </a>

                <a
                  href={storeInfo.is_android_released ? storeInfo.android_url : "#!"}
                  target={storeInfo.is_android_released ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className="store-button google-play-button"
                  onClick={(e) =>
                    handleStoreClick(e, storeInfo.is_android_released, "Google Play", storeInfo.android_url)
                  }                  
                >
                  <span className="store-icon">
                    <svg width="22" height="24" viewBox="0 0 512 512">
                      <path fill="#00f0ff" d="M12 21.7L276.2 256 12 490.3V21.7z" />
                      <path fill="#00e676" d="M362.8 169.4L276.2 256l86.6 86.6 48.3-27.6c13.8-7.9 22.9-22.7 22.9-39 0-16.3-9.1-31.1-22.9-39l-48.3-27.6z" />
                      <path fill="#ff3d00" d="M12 490.3l264.2-234.3 86.6 86.6-261.2 149.3c-7 4-15 6.1-23.1 6.1-22.9 0-42.5-16.4-46.5-39-3-16.3 3-32.8 20-32.8z" />
                      <path fill="#ffea00" d="M12 21.7c-17 0-23 16.5-20 32.8 4 22.6 23.6 39 46.5 39 8.1 0 16.1-2.1 23.1-6.1L322.8 238l-86.6 86.6L12 21.7z" />
                    </svg>
                  </span>
                  <span className="store-btn-text">
                    <strong>Google Play</strong>
                  </span>
                </a>
              </div>

              <div className="download-notes">
                <div>
                  <span>◉</span>
                  Miễn phí tải xuống
                  <small>Chỉ hỗ trợ tra cứu kết quả</small>
                </div>
                <div>
                  <span>✓</span>Không bán vé số
                </div>
              </div>
            </div>

            <div className="download-promo-logo">
              <img src={appLogo} alt="Logo" className="promo-logo-img" />
            </div>
          </div>
        </div>
      </section>  
    </div>
  );
}